import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-02.svg';
import icn_02 from '../../assets/img/landingPage/hyperautomation/icn_hyperautomation-02.png';
import icn_03 from '../../assets/img/landingPage/management/icn_management_01.png';
import icn_04 from '../../assets/img/landingPage/devStudio/dev-s_01_project.svg';

import icn_dev from '../../assets/img/landingPage/hyperautomation/icono_DS.svg';
import icn_vs from '../../assets/img/landingPage/hyperautomation/icono_VS.svg';
import icn_connectors from '../../assets/img/landingPage/hyperautomation/AVAP_Connector_Icono.svg';
import icn_vision from '../../assets/img/landingPage/hyperautomation/AVAP_Vision.svg';
import icn_mesh from '../../assets/img/landingPage/hyperautomation/AVAP_ManagementMesh.svg';


import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/hyperautomation/Hyperautomation01.png';


const Hyperautomation = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'AVAP Dev Language',
            text: "Define APIs with embedded automation logic to streamline tasks and decision-making.",
            altDescription: "Key Feature 01",
            image: product_gateway,
        },
        Key_Feature_02: {
            title: "AVAP Virtual Server",
            text: "Orchestrate complex workflows and services across distributed systems.",
            altDescription: "Orchestrate complex workflows and services across distributed systems.",
            image: product_gateway,
        },
        Key_Feature_03: {
            title: 'AVAP API Connectors',
            text: 
            "Integrate legacy and modern platforms seamlessly through standardized APIs.",
            altDescription: 'Integrate legacy and modern platforms seamlessly through standardized APIs.',
            image: product_gateway,
        },
        Key_Feature_04: {
            title: 'AVAP Vision & AI Analytics',
            text: 
            "Gain real-time insights to monitor, analyze, and optimize automated processes.",
            altDescription: 'Gain real-time insights to monitor, analyze, and optimize automated processes.',
            image: product_gateway,
        },
        Key_Feature_05: {
            title: 'AVAP Mesh Manager',
            text: 
            "Manage and scale automation infrastructure across multiple environments and domains.",
            altDescription: 'Manage and scale automation infrastructure across multiple environments and domains.',
            image: product_gateway,
        },
    }

//Key Benefits Bento
    const items2 = [
            {
              icon: icn_01,
              title: 'Public Sector',
              paragraphs: [
                'Automate full case management lifecycles—from submission to approval, with integrated e-signature and AI-based classification.',
              ],
            
            },
            {
              icon: icn_02,
              title: 'Finance & Insurance',
              paragraphs: [
                'Streamline claim processing, fraud detection, compliance workflows, and reconciliations.',
              ]
            },
    
            {
              icon: icn_03,
              title: 'Customer Experience',
              paragraphs: [
                'Intelligent chatbots, workflow orchestration, and contextual automation for support teams.',
              ]
            },
            {
              icon: icn_04,
              title: 'Operations & Logistics',
              paragraphs: [
                'Predictive routing, inventory automation, and real-time orchestration of supply chain components.',
              ]
            },
          ];
          
         const breakpointColumnsObj = {
            default: 2, //Cambio de columnas verticales
            1100: 2,
            700: 1
          
        };


    //Key Benefits Bento
    const items = [
        {
          icon: icn_01,
          title: 'Eliminate operational silos and inefficiencies',
          paragraphs: [
            'Simulate and deploy APIs without affecting production systems.',
          ],
        
        },
        {
          icon: icn_02,
          title: 'Reduce manual workloads and accelerate throughput',
          paragraphs: [
            'Use Gen-AI to automate logic, reduce redundancies, and speed up service delivery',
          ]
        },

        {
          icon: icn_03,
          title: 'Improve accuracy, agility, and real-time visibility',
          paragraphs: [
            'Monitor and track every interaction.',
          ]
        },
        {
          icon: icn_04,
          title: 'Free up teams to focus on innovation and value creation',
          paragraphs: [
            'Empower more teams to participate in digital transformation.'
          ]
        },
      ];
      
    const breakpointColumnsObj2 = {
        default: 4, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    //How AVAP Framework Powers Hyperautomation
    const items3 = [
        {
          icon: icn_dev,
          title: 'AVAP Dev Language',
          paragraphs: [
            'Define APIs with embedded automation logic to streamline tasks and decision-making.',
          ],
        
        },
        {
          icon: icn_vs,
          title: 'AVAP Virtual Server',
          paragraphs: [
            'Orchestrate complex workflows and services across distributed systems.',
          ]
        },

        {
          icon: icn_connectors,
          title: 'AVAP API Connectors',
          paragraphs: [
            'Integrate legacy and modern platforms seamlessly through standardized APIs.',
          ]
        },
        {
          icon: icn_vision,
          title: 'AVAP Vision & AI Analytics',
          paragraphs: [
            'Gain real-time insights to monitor, analyze, and optimize automated processes.'
          ]
        },
         {
          icon: icn_mesh,
          title: 'AVAP Mesh Manager',
          paragraphs: [
            'Manage and scale automation infrastructure across multiple environments and domains.'
          ]
        },
      ];
      
    const breakpointColumnsObj3 = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0">Hyperautomation</h1>
                    <p className="fl-title m-0 gradient-text fl-txt-container-s">Build, integrate, and orchestrate your intelligent processes — all in one platform.</p>
                                {/*<p className="fl-text fl-txt-container-s" >
                                With AVAP Framework, government agencies and public institutions can modernize their systems, unify data, and expose services securely,  all through modular, reusable APIs. Unlock real-time visibility, accelerate project delivery, and simplify compliance with an API-first approach built for scale and trust.
                                </p>*/}
                                {/*Boton Contact Us*/}  
                                {/*<a className="glowBtn-dark mb-4 " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>*/}
              </section>

        

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-0"
                        style={{ width: '46%', maxWidth: '800px', height: 'auto' }}
                    />
                
                    <h2 className='fl-subtitle pt-8'>Redefine Automation. At Scale.</h2>
                        <p className="fl-text fl-txt-container-s" >
                        Hyperautomation is not just the next stage in automation, it’s a strategic approach that integrates technologies like RPA, AI, APIs, iPaaS, and low-code platforms to automate end-to-end business processes with intelligence, speed, and scale.
                        </p>
                        <p className="fl-text fl-txt-container-s" >
                        AVAP Framework helps you move beyond isolated scripts and task automation, toward a fully orchestrated, API-first infrastructure where processes are dynamic, composable, and intelligent by design.
                        </p>
                    {/*Boton Contact Us*/}  
                        <a className="glowBtn-dark pb-5" style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
    
                 <section className='container'>   
                 <div className="fl-card-border container text-center">
                    <h2 className="fl-title mt-0 py-2 gradient-text fl-title m-4">What is Hyperautomation?</h2>

                    <p className="fl-text fl-txt-container-s">“A disciplined, business-driven approach used by organizations to rapidly identify, vet, and automate as many business and IT processes as possible.”
                    </p>
                    <p className="fl-text fl-txt-container-s bold">- Gartner -</p>
                    <br/>
                    <p className="fl-subtitle-s">It combines:<p/> 
                    {/* Sección Bullets */}
                    <ul className="fl-text fl-txt-container">
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> RPA:</strong> Task-level automation.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> AI/ML:</strong> Cognitive capabilities and smart decisions.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> BPM:</strong> Business process modeling and orchestration.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> iPaaS:</strong> Seamless integration across platforms.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> APIs & microservices:</strong> Agile service composition.</li> 
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> Low-code/no-code tools:</strong> Democratized automation development.</li> 
                        </ul>
                    </p>
                    
                    {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container pt-8">
                <div className="fl-title text-center mb-5">
                Why It Matters
                    </div>
                    
                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        <p className="p">{item.title}</p>
                        </div>
                    ))}
                    </Masonry>
                </div>
                </div>
                </section>

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container pt-8">
                <div className="fl-title text-center mb-5 gradient-text">
                Where Hyperautomation Applies
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item, idx) => (
                        <div key={idx} className="grayBox fl-card text-center">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>
                {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark mb-4 " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>

                   {/* <h2 className="fl-title m-0 gradient-text fl-title m-4">Connect everything. Empower everyone.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Integration unifies the power of automation, data flow, and intelligent orchestration. With native virtualization and AI assistance, AVAP Framework helps developers and business teams integrate applications, services, and data sources — across clouds, on-premises systems, and legacy architectures — without friction. Free your teams from bottlenecks and legacy dependencies with a platform that adapts to change, scales effortlessly, and delivers real-time integration insights.
                    </p>*/}

                </section>

                {/*MASONRY How AVAP Framework Powers Hyperautomation */}
                <div className="container pt-8">
                <div className="fl-title text-center mb-5 gradient-text fl-txt-container-s">
                How AVAP Framework Powers Hyperautomation
                </div>
                <p className='pt-2 pb-7 fl-title-center fl-subtitle fl-txt-container-s'>AVAP was designed to support intelligent, end-to-end automation strategies from the ground up. Its components work together to accelerate hyperautomation at every layer:
                </p>
                    <Masonry
                    breakpointCols={breakpointColumnsObj3}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items3.map((item, idx) => (
                        <div key={idx} className="grayGradient fl-card text-center">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>
                {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark mb-4 " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>

                   {/* <h2 className="fl-title m-0 gradient-text fl-title m-4">Connect everything. Empower everyone.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Integration unifies the power of automation, data flow, and intelligent orchestration. With native virtualization and AI assistance, AVAP Framework helps developers and business teams integrate applications, services, and data sources — across clouds, on-premises systems, and legacy architectures — without friction. Free your teams from bottlenecks and legacy dependencies with a platform that adapts to change, scales effortlessly, and delivers real-time integration insights.
                    </p>*/}


                {/* Sección Key Features */}
               {/* <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                           
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0 fl-txt-container-s gradient-text">How AVAP Framework Powers Hyperautomation</p>
                            <p className='pt-2 fl-title-center fl-subtitle fl-txt-container-s'>AVAP was designed to support intelligent, end-to-end automation strategies from the ground up. Its components work together to accelerate hyperautomation at every layer:
                            </p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>*/}

                {/* Sección built for secure */} 
                <section className="container fl-text-center">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                            <div className="blob"></div>
    

                                <div>
                                    <h3 className='fl-subtitle'>Together, these tools enable organizations to move from siloed automation to intelligent, connected, and adaptive systems—all within one unified framework.
                                    {/*Boton Contact Us*/}  
                                    <a className="glowBtn-dark " 
                                    href="/contact" 
                                    target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                                    </h3>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Sección Built */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Built for modern teams</h3>
                                    <p>AVAP Integration empowers both IT and business users with no-code/low-code tools and reusable virtual connectors for:
                                    </p>*/} 
                                    {/* Sección Bullets */}
                                   {/* <ul className="fl-bullets fl-text  .fl-txt-container-s " >
                                    <li className="fl-bullets">Cloud & SaaS platforms</li>
                                    <li className="fl-bullets">On-prem legacy systems</li>
                                    <li className="fl-bullets">Databases & messaging systems</li>
                                    <li className="fl-bullets">Internal and third-party APIs</li>
                                    </ul>
                                    <p>Break data silos and give teams the freedom to build connected workflows across any system.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

                
                {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Unify your data
                                </p>
                                <p className="fl-text">
                                Create a single source of truth by linking all your systems, regardless of format or source.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Accelerate delivery
                                </p>
                                <p className="fl-text">
                                Start faster with AI-assisted configuration, smart templates, and reusable integration assets.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Make integration intelligent
                                </p>
                                <p className="fl-text">
                                Predict bottlenecks, monitor flows, and auto-tune performance with AVAP’s Gen-AI engine.

                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Protect every connection
                                </p>
                                <p className="fl-text">
                                Enforce policies across all connections with dynamic authentication, rate limiting, and encryption — built in.

                                </p>
                            </div>
                        </div>
                        
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Measure and improve
                                </p>
                                <p className="fl-text">
                                Track integration KPIs in real time with built-in analytics and smart dashboards.

                                </p>
                            </div>
                        </div>

                    </div>
                </section>*/} 

                


                {/* Sección built for secure */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Designed for your architecture</h3>
                                    <p>Whether you're operating in the cloud, on-prem, or in hybrid environments, AVAP Framework adapts seamlessly to your infrastructure and governance model.

                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Hyperautomation;
